import {TranslateSvc} from '../../services/TranslateSvc';

class TitleBlock implements ng.IComponentController {
    tbTitle: string;
    description: string;
    color: 'white' | 'gray' | 'black';
    size: 'small' | 'medium' | 'prelarge' | 'large';

    constructor(private $sce: ng.ISCEService,
                private  TranslateSvc: TranslateSvc) {
        const mapText    = _.compose(this.getHtml, this.translate);
        this.tbTitle     = mapText(this.tbTitle);
        this.description = mapText(this.description);
    }

    private getHtml = (html: string) => {
        return this.$sce.trustAsHtml(html);
    };

    private translate = (str: string) => {
        return this.TranslateSvc.has(str) ? this.TranslateSvc.get(str) : str;
    };
}

angular.module('animatronApp.titleBlock', []).component('titleBlock', {
    bindings: {
        tbTitle: '<',
        description: '<',
        color: '@',
        size: '@'
    },
    controller: TitleBlock,
    templateUrl: require('landing-template/components/title-block.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/TitleBlock.ts